import {inject, Injectable} from '@angular/core';
import {
  ChartMapType,
  DatasetConfig,
  FieldsLineChartParams,
  GetDatasetConfigParams,
  LineChartDataParams
} from "../types/line-chart-modal.types";
import {RecordData, RecordTableColumnParams} from "../../../../types/records-table.types";
import {getColorPalette} from "../configs/line-chart-config";
import {chartPrefixMap} from "../configs/line-chart-modal-config";
import {LineChartApiService} from "./line-chart-api.service";

@Injectable({
  providedIn: 'root'
})
export class LineChartModalService {
  private lineChartApiService: LineChartApiService = inject(LineChartApiService);

  public getColumnsSelectData(fields: Array<RecordTableColumnParams>): Array<FieldsLineChartParams> {
    return fields
      .filter(field => {
        const normalizedType = field.type?.toUpperCase();
        return normalizedType === 'NUMERIC' &&
          field.omit === false;
      })
      .map(field => ({
        key: field.key,
        value: field.name || field.key
      }));
  }

  public getDatasetConfig({ key, data, columnsSelectData, index }: GetDatasetConfigParams): DatasetConfig {
    const color = getColorPalette(columnsSelectData.length)[index];

    return {
      label: columnsSelectData.find(i => i.key === key)?.value,
      data: data,
      fill: false,
      borderColor: color.border,
      backgroundColor: color.background,
      tension: 0.1,
      pointBackgroundColor: color.border,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: color.border
    };
  }

  public getChartType(parentUrl?: string): ChartMapType | null {
    if (!parentUrl) { return null; }
    const cleanUrl = parentUrl.replace('article-', '');

    for (const prefix in chartPrefixMap) {
      if (cleanUrl.startsWith(prefix)) {
        return chartPrefixMap[prefix];
      }
    }

    return null;
  }

  public getLineChartData(lineChartDataParams: LineChartDataParams): Promise<Array<RecordData>> {
    return new Promise((resolve, reject) => {
      this.lineChartApiService.getLineChartData(lineChartDataParams).subscribe({
        next: (recordData) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }
}
